import React, { useEffect, useState } from "react";
import * as Icons from "lucide-react";
import { api } from "@/lib/api";
import { LINK_META } from "@/lib/workspace";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Every assigned action must deliver an approved priority, a business-health improvement or a KPI.
export function ActionLinkPicker({ orgId, value, onChange, label = "What does this deliver?", testId = "link-picker" }) {
  const [opts, setOpts] = useState(null);
  useEffect(() => {
    if (!orgId) return;
    api.get(`/workspace/link-options?org_id=${orgId}`).then((r) => setOpts(r.data))
      .catch(() => setOpts({ priorities: [], improvements: [], kpis: [] }));
  }, [orgId]);
  const type = value?.link_type || "priority";
  const items = opts ? opts[LINK_META[type].key] : [];
  return (
    <div data-testid={testId}>
      <Label>{label}</Label>
      <div className="mt-1 grid grid-cols-[132px_1fr] gap-2">
        <Select value={type} onValueChange={(t) => onChange({ link_type: t, link_id: "" })}>
          <SelectTrigger data-testid={`${testId}-type`}><SelectValue /></SelectTrigger>
          <SelectContent>
            {Object.entries(LINK_META).map(([k, m]) => <SelectItem key={k} value={k}>{m.label}</SelectItem>)}
          </SelectContent>
        </Select>
        <Select value={value?.link_id || undefined} onValueChange={(id) => onChange({ link_type: type, link_id: id })} disabled={!opts}>
          <SelectTrigger data-testid={`${testId}-item`}>
            <SelectValue placeholder={!opts ? "Loading…" : items.length ? `Choose a ${LINK_META[type].label.toLowerCase()}` : "None available"} />
          </SelectTrigger>
          <SelectContent>
            {items.map((o) => (
              <SelectItem key={o.id} value={o.id}>
                <span className="block truncate">{o.label}</span>
                {o.group && <span className="block text-[11px] text-[#1E2D44]/45">{o.group}</span>}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <p className="mt-1.5 flex items-center gap-1.5 text-[11px] text-[#1E2D44]/50">
        <Icons.Link2 size={12} /> Priorities come from approved (active) 90-day plans; improvements from the latest Business Health assessment.
      </p>
    </div>
  );
}

export function LinkChip({ a, className = "" }) {
  const m = LINK_META[a?.link_type];
  if (!m) return null;
  const I = Icons[m.icon] || Icons.Link2;
  return (
    <span className={`inline-flex max-w-full items-center gap-1 rounded-md bg-[#0B1729]/[0.05] px-1.5 py-0.5 text-[11px] text-[#1E2D44]/70 ${className}`} data-testid="link-chip">
      <I size={11} className="shrink-0 text-[#B87F1E]" />
      <span className="truncate">{a.link_label || a.priority_title || m.label}</span>
    </span>
  );
}
